// TODO - replace with an ADS Component https://qbe-appservices.atlassian.net.mcas.ms/browse/AD1-393

import InputAdornment from '@mui/material/InputAdornment';
import type { TextFieldProps } from '@qbe/ads-core';
import { NumericFormat } from '@qbe/ads-core';
import { FieldValidation, useFieldValidation } from 'hooks';
import React, { useState } from 'react';

import { TextFieldState } from '~/types/enums';

interface NumberFormatValues {
  floatValue: number | undefined;
  formattedValue: string;
  value: string;
}

export interface CurrencyFieldProps<T> extends TextFieldProps {
  errorText: string;
  warningText?: string;
  fieldValidation: FieldValidation<T>;
}

const CurrencyField = <T,>({
  id,
  name,
  defaultValue,
  warningText,
  label,
  helperText,
  errorText,
  required,
  onChange,
  fieldValidation,
  error,
  ...restProps
}: CurrencyFieldProps<T>) => {
  const [amount, setAmount] = useState(defaultValue || '');

  const { debouncedChangeHandler, textFieldState } = useFieldValidation(fieldValidation);

  const handleOnValueChange = (values: NumberFormatValues) => {
    const unFormattedValue = values.value;
    setAmount(unFormattedValue);
    debouncedChangeHandler(unFormattedValue !== '' ? Number(unFormattedValue) : '');
  };

  const isError = error || textFieldState === TextFieldState.Error;
  const isWarning = textFieldState === TextFieldState.Warning;
  let statusText;
  if (isError) {
    statusText = errorText;
  } else if (isWarning) {
    statusText = warningText;
  } else {
    statusText = helperText;
  }

  return (
    <NumericFormat
      // customInput={TextField}
      thousandSeparator
      onValueChange={handleOnValueChange}
      onChange={onChange}
      InputProps={{ startAdornment: <InputAdornment position="start">$</InputAdornment> }}
      id={id}
      name={name}
      label={label}
      data-track-value="mask"
      value={amount}
      helperText={statusText}
      warning={isWarning}
      error={isError}
      displayIcon
      required={!!required}
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-expect-error
      type="text"
      {...restProps}
    />
  );
};

export default CurrencyField;
